import { createContext } from 'react'

// Opens the node's configuration sheet (its name and when it shows), given
// by the node view where the note can be changed; absent otherwise.
export const ObservationNodeConfigure = createContext<(() => void) | null>(null)

// Whether the configuration sheet is open on this node, to mark it.
export const ObservationNodeConfiguring = createContext(false)
